import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=2bce75fa&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\deploy\\wordpress\\campbellsoupca+production\\wp-content\\themes\\pfw-wp-campbell-soup-ca\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bce75fa')) {
      api.createRecord('2bce75fa', component.options)
    } else {
      api.reload('2bce75fa', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=2bce75fa&", function () {
      api.rerender('2bce75fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/frontend/paginate/Paginate.vue"
export default component.exports